import React from 'react';
import dashboardReducer, {defaultState} from "./dashboard-reducer";
import actions from "./dashboard";

const DashboardContext = React.createContext();

function useDashboardContextValue() {
    const [state, dispatch] = React.useReducer(dashboardReducer, defaultState);

    const {user_id, user, subscription, history} = state;

    const setUserId = React.useCallback((id) => dispatch(actions.setUserId(id)), []);
    const loadUser = React.useCallback((user) => dispatch(actions.setUser(user)), []);
    const loadSubscription = React.useCallback((subscription) => dispatch(actions.setSubscription(subscription)), []);
    const loadHistory = React.useCallback((history) => dispatch(actions.loadHistory(history)), []);

    return React.useMemo(() => {
        return {
            state,
            user_id, setUserId,
            user, loadUser,
            subscription, loadSubscription,
            history, loadHistory,
        }
    }, [
        state,
        user_id, setUserId,
        user, loadUser,
        subscription, loadSubscription,
        history, loadHistory,
    ]);
}

function DashboardProvider(props) {
    const value = useDashboardContextValue();
    return <DashboardContext.Provider value={value} {...props} />
}

function useDashboard() {
    const context = React.useContext(DashboardContext);
    if(!context) {
        throw new Error("useDashboard must be used within a DashboardProvider");
    }

    return context;
}

export {
    DashboardProvider,
    useDashboard,
}